export default "__VITE_ASSET__C$UQTD6M__"